export const ADD_STORE = 'ADD_STORE';

export const DELETE_STORE = 'DELETE_STORE';